import React from 'react';
import { Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Maintenance: React.FC = () => {
  const { i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  return (
    <div className="min-h-screen bg-brand-light flex flex-col items-center justify-center p-4">
      <div className="bg-white border border-slate-200 rounded-[2.5rem] p-12 max-w-2xl w-full text-center shadow-xl animate-in fade-in zoom-in duration-500">
        <div className="w-24 h-24 bg-brand-blue/10 text-brand-blue rounded-full flex items-center justify-center mx-auto mb-8 animate-pulse">
          <Settings className="w-12 h-12" />
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 tracking-tight">
          {isEn ? "We'll be back soon!" : "Kısa bir süreliğine bakımdayız!"}
        </h1>
        
        <p className="text-lg text-slate-500 mb-8 max-w-lg mx-auto">
          {isEn 
            ? "We are currently updating our website to provide you with a better experience. Thank you for your patience." 
            : "Size daha iyi bir deneyim sunabilmek için web sitemizde güncellemeler yapıyoruz. Anlayışınız için teşekkür ederiz."}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="mailto:info@patoyazilim.com" className="bg-brand-blue text-white px-8 py-4 rounded-2xl font-bold hover:bg-brand-blue/90 transition-all w-full sm:w-auto">
            {isEn ? "Contact Us" : "Bize Ulaşın"}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
